﻿import { closeBackDrop, pipe } from "./HelperFunctions";

enum VIDEO_PROVIDERS {
    YOUTUBE = "youtube",
    VIMEO = "vimeo",
}

const queryParamDictionary: {
    [key: string]: { name: string; value: string }[];
} = {};
queryParamDictionary[VIDEO_PROVIDERS.YOUTUBE] = [
    { name: "enablejsapi", value: "1" },
    { name: "autoplay", value: "1" },
];
queryParamDictionary[VIDEO_PROVIDERS.VIMEO] = [
    { name: "enablejsapi", value: "1" },
    { name: "autoplay", value: "1" },
];

const VIDEO_ELEMENTS = [
    { ROOT_CLASS: "text-video--left", HAS_MODAL: false },
    { ROOT_CLASS: "text-video", HAS_MODAL: false },
    { ROOT_CLASS: "full-width-video", HAS_MODAL: true },
    { ROOT_CLASS: "job-details-cta-video", HAS_MODAL: true },
];

export const VideoClickHandler = () => {
    const playBtns = document.querySelectorAll(".play-btn");
    playBtns.forEach((btn) => {
        btn.addEventListener("click", (e) => {
            const rootElement = getRootElement(e);
            const videoSrc = getVideoSrc(rootElement);
            const formattedUrl = formatVideoUrl(videoSrc);
            updateIframeUrl(rootElement, formattedUrl);
            displayIframe(rootElement);
            displayModalIfrequired(rootElement);
        });
    });

    closeBackDrop(clearIframe);
};

const getRootElement = (e) => {
    let root;
    const target = e.target as HTMLElement;
    VIDEO_ELEMENTS.forEach((element) => {
        const rootElement = element.ROOT_CLASS.toString();
        if (target.closest(`.${rootElement}`)) {
            root = target.closest(`.${rootElement}`);
        }
    });

    return root;
};

const getVideoSrc = (root) => {
    const iframe = root.querySelector("iframe");
    const videoSrc = oneTrustCheck(iframe);
    return videoSrc;
};

const getVideoProvider = (src: string) => {
    for (let provider in VIDEO_PROVIDERS) {
        if (src.includes(VIDEO_PROVIDERS[provider])) {
            return VIDEO_PROVIDERS[provider];
        }
    }
    return null;
};

const formatVideoUrl = (videoSrc) => {
    const newSrc = new URL(videoSrc);

    const provider = getVideoProvider(videoSrc);
    if (provider) {
        const qparams = queryParamDictionary[provider];
        qparams.forEach((p) =>
            newSrc.searchParams.append(p.name, p.value.toString())
        );
    }

    return newSrc.href;
};

const updateIframeUrl = (root, newSrc) => {
    const iframe = root.querySelector("iframe");
    iframe.setAttribute("src", newSrc);
};

const displayIframe = (root) => {
    root.classList.add("active");
};

const displayModalIfrequired = (root) => {
    const modal = document.querySelector<HTMLElement>(".general-modal-bg");

    if (!modal) {
        return;
    }

    VIDEO_ELEMENTS.forEach((el) => {
        if (root.classList.contains(el.ROOT_CLASS) && el.HAS_MODAL === true) {
            modal?.classList.remove("general-modal-bg--hidden");
        }
    });
};

const oneTrustCheck = (iframe: HTMLIFrameElement) => {
    if (iframe.attributes["data-src"] !== undefined) {
        return iframe.getAttribute("data-src");
    }

    return iframe.getAttribute("src");
};

const clearIframeSrc = (iframe) => {
    iframe.contentWindow.postMessage(
        '{"event":"command","func":"stopVideo","args":""}',
        "*"
    );
};

const findActiveVideo = (): HTMLElement | null => {
    const activeElement = VIDEO_ELEMENTS.find((el) => {
        return document.querySelector(`.${el.ROOT_CLASS}.active`);
    });

    return activeElement
        ? document.querySelector(`.${activeElement.ROOT_CLASS}.active`)
        : null;
};

const clearIframe = () => {
    const el: HTMLElement | null = findActiveVideo();
    const iframe = el?.querySelector("iframe");

    if (!iframe) {
        return;
    }

    clearIframeSrc(iframe);
    el?.classList.remove("active");
};
